<template>
    <v-dialog v-model="show" max-width="700" persistent no-click-animation>
        <div class="QCBatchCreator">
            <div class="dialog-header">
                <div>{{ $f.tc('download') }} {{ $f.tc('report') }}</div>
                <v-btn flat icon @click="close()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <v-form v-model="formValid" ref="form" @submit="submit"
                    style="max-height: 500px; overflow-y: auto; padding: 10px"
                    class="fci-scrollbar">
                <div class="display-flex" style="padding-bottom: 20px">
                    <div style="width: 50%;box-sizing: border-box;padding-right: 10px">
                        <!--Email-->
                        <div class="label">{{ $f.tc('email') }}</div>
                        <v-text-field
                            v-model="email"
                            :rules="formRules.email"
                            class="input-custom"
                            disabled
                        ></v-text-field>
                    </div>
                    <div style="max-width: 50%">
                        <div class="label">{{ $f.tc('time') }}</div>
                        <TimeRangePicker ref="TimeRangePicker" v-model="timeRange"
                                         :button-class-name="'btn-primary'"></TimeRangePicker>
                    </div>
                </div>
            </v-form>
            <div class="dialog-footer justify-center">
                <div class="btn-primary" @click="submit">
                    {{ $f.tc('download') }}
                    <img class="ml-12" src="/img/save-member.svg">
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker'
import { mapState } from 'vuex'
import QcCampaignService from '@/services/qc.campaign.service'
import moment from 'moment'

export default {
    name: 'QCCampaignExport',
    components: { TimeRangePicker },
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            timeRange: 'today',
            model: {},
            email: '',
            timeRangeExport: 90,
        }
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
        }),
    },
    methods: {
        open () {
            this.show = true
            this.email = this.$store.state.user.profile.email
        },
        close () {
            this.show = false
            this.resetModel()
            this.$refs.form.reset()
        },
        resetModel () {
            this.timeRange = 'today'
        },
        submitValidForm () {
            let i18n = {
                action: this.$t('download'),
                item: this.$t('report')
            }
            let timeStamp = this.$refs.TimeRangePicker.getTimestamp()
            this.model.from_time = timeStamp.from
            this.model.to_time = timeStamp.to
            if (!this.checkRangeExport(this.model.from_time, this.model.to_time)) {
                this.$appService.toastError('Period must be less than ' + this.timeRangeExport + ' days')
                return
            }
            this.$appService.showLoading()
            let qcCampaignId = this.qcCampaign ? this.qcCampaign.id : this.$route.params.QCCampaignId
            QcCampaignService.exportReportCampaign(qcCampaignId, this.model).finally(() => {
                    this.$appService.toastSuccess('Download successfully, the report will be sent to your email')
                    this.$refs.form.reset()
                    this.close()
                    this.$appService.hideLoading()
                }
            )
        },
        checkRangeExport (from, to) {
            // from, to is unix timestamp
            this.timeRangeExport = this.qcCampaign['time_range_export_report'] ? this.campaign['time_range_export_report'] : 90
            if (!isNaN(this.timeRangeExport)) {
                this.timeRangeExport = 90
            }
            return (to - from) / (1000 * 24 * 60 * 60) < this.timeRangeExport
        },
    }
}
</script>

<style scoped lang="scss">
.QCBatchCreator {
    background: #FFFFFF;
    position: relative;
    border-radius: 0 !important;
    overflow: hidden;

    .dialog-header {
        padding: 0 0 0 12px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi";
        font-size: 13px;
    }

    ::v-deep {
        .v-tabs__item--active {
            background: #25B570 !important;
        }

        .v-tabs__item {
            background: #E7EDF5;
        }

        .v-tabs__bar {
            padding: 12px;
        }

        .v-tabs .v-tabs__bar .v-tabs__item {
            margin-right: 0 !important;
            border-radius: 0 !important;
        }

        .v-tabs__container {
            .v-tabs__div {
                margin-right: 10px;
                height: 70px;
                width: 254px !important;
                text-transform: none !important;
                font-weight: 400;

                &:last-child {
                    margin-right: 0 !important;
                }
            }
        }

        .v-tabs__item {
            align-items: flex-start;
            flex-direction: column;
        }
    }
}

.btn-custom {
    margin-left: 6px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}
</style>
